import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { register } from '@vanguard/cert-layer/dist/cert-layer.umd.js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

register();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
